export enum ScoreRange {
  NotApplicable = 'not-applicable',
  VeryLow = 'very-low',
  Low = 'low',
  Moderate = 'moderate',
  High = 'high',
  VeryHigh = 'very-high',
  Unscored = 'unscored',
}

export enum ScoreColorVariant {
  NotApplicable = 'notApplicable',
  VeryLow = 'veryLow',
  Low = 'low',
  Moderate = 'moderate',
  High = 'high',
  VeryHigh = 'veryHigh',
}

// Keys are the legacy tier identifiers (kept so existing references resolve);
// the string values are the user-facing copy and follow the score-tier scale.
export enum ScoreDescriptions {
  NotApplicable = 'Informational',
  VeryLow = 'Poor',
  Low = 'Weak',
  Moderate = 'Moderate',
  High = 'Fair',
  VeryHigh = 'Optimized',
  Unscored = 'Informational',
}

export const HERO_SCORE_COMPONENTS = [
  {
    key: 'relevance',
    title: 'Relevance',
    description:
      'Measures how closely your hero image reflects the visual patterns proven to convert within your category.',
    field: 'hero_score_local_support',
  },
  {
    key: 'distinctiveness',
    title: 'Distinctiveness',
    description: 'Visual separation from similarly searched competitors.',
    field: 'hero_score_category_edge',
  },
  {
    key: 'visual_impact',
    title: 'Visual Impact',
    description: 'Color, lighting, and composition relative to category benchmarks.',
    field: 'hero_score_heroism',
  },
  {
    key: 'retail_readiness',
    title: 'Retail Readiness',
    description: 'Measures image quality and compliance to minimize shopper friction.',
    field: 'hero_score_technical_integrity',
  },
] as const;

export type HeroScoreComponent = (typeof HERO_SCORE_COMPONENTS)[number];
export type HeroScoreComponentKey = HeroScoreComponent['key'];
export type HeroScoreField = HeroScoreComponent['field'];

/** What a score reads when no scoring can run because there is no product category to score against. */
export const NEEDS_CATEGORY_SCORE_LABEL = 'Needs a category';
